import type { SVGProps } from 'react';

export const WarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 21.5L12 2.5L23 21.5H1ZM19.5297 19.4983L11.9997 6.48828L4.46973 19.4983H19.5297ZM11 16.5V18.5H13V16.5H11ZM11 10.5H13V14.5H11V10.5Z"
      fill={props.fill ?? '#E99921'}
    />
  </svg>
);

export default WarningIcon;
